module.exports = __webpack_public_path__ + "static/media/edit.8de6133e.svg";